
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8fb5x", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $T1bCI = parcelRequire("T1bCI");


var $jkVM2 = parcelRequire("jkVM2");


var $bJX6u = parcelRequire("bJX6u");


var $luv00 = parcelRequire("luv00");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $dA1Sn = parcelRequire("dA1Sn");





var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $3jwuS = parcelRequire("3jwuS");


var $e4o8D = parcelRequire("e4o8D");


var $jMyy4 = parcelRequire("jMyy4");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");




/**
 * @generated SignedSource<<f6714836f4a0dd3ccbdf24817df5c932>>
 * @relayHash 81e92b7bef30c91df7d1d5fc36cdd372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8135d45ff19837151e07f9b2e9ace783267d3926cd38525a66d27917a361fc72
const $6900e8f8fbd4b479$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "color"
    }, v4 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCallerPermitted"
                        }
                    ]
                },
                {
                    "condition": "isDraft",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "format",
                                    "value": "USER_FRIENDLY"
                                }
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ],
                            "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "AvailableContentStates",
            "kind": "LinkedField",
            "name": "availableContentStates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "customContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "spaceContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "81e92b7bef30c91df7d1d5fc36cdd372",
            "id": "8135d45ff19837151e07f9b2e9ace783267d3926cd38525a66d27917a361fc72",
            "metadata": {},
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "operationKind": "query",
            "text": "query LivePagesByLineWithContributorsComponentEditorContentStateQuery($contentId:ID!,$isDraft:Boolean!){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted},contentStateLastUpdated(format:USER_FRIENDLY)@skip(if:$isDraft){value}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$6900e8f8fbd4b479$var$node.hash = "cbad882df31b75e4699e60f1bcf2ae8b";
var $6900e8f8fbd4b479$export$2e2bcd8739ae039 = $6900e8f8fbd4b479$var$node;









var $gdv5Z = parcelRequire("gdv5Z");


var $laFNM = parcelRequire("laFNM");


var $63EIj = parcelRequire("63EIj");











var $7om8k = parcelRequire("7om8k");


var $7QM6o = parcelRequire("7QM6o");





var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $4FHTF = parcelRequire("4FHTF");


var $3FlVr = parcelRequire("3FlVr");


var $83sfO = parcelRequire("83sfO");





var $1NF8X = parcelRequire("1NF8X");





var $5UrgY = parcelRequire("5UrgY");

const $06f66a283e23582e$var$i18n = (0, $aXWIB.defineMessages)({
    addNew: {
        id: "live-pages-features.byline.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "live-pages-features.byline.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $06f66a283e23582e$var$dotStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-050, 4px)",
    width: "var(--ds-space-050, 4px)",
    backgroundColor: 'color.background.brand.bold',
    borderRadius: 'radius.full',
    alignSelf: 'center',
    transition: 'opacity 300ms ease-in-out'
});
const $06f66a283e23582e$var$floatingContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'left',
    transition: 'left 600ms',
    marginBottom: 'space.025',
    height: '28px',
    marginTop: 'space.025'
});
const $06f66a283e23582e$export$37ba4ba009bc421f = ({ contentId: contentId, spaceId: spaceId, isDisabled: isDisabled = false, contentType: contentType, isCurrentUserContributor: isCurrentUserContributor = false, editorBylineContainerRef: editorBylineContainerRef })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Used when we want to allow the user to select reactions from the summary view popup
    const customIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))), {
        testId: "emoji-add-icon",
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    });
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const { isEligible: isEligibleReactionsFeedbackPageReturn } = (0, $5UrgY.useIsEligibleReactionsFeedbackPageReturn)({
        contentId: contentId,
        isContributor: Boolean(isCurrentUserContributor),
        skip: !(0, $9wGTI.fg)('cc-engagement-reaction-feedback-page-return-kill'),
        source: 'livePage'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $06f66a283e23582e$var$floatingContainerStyles,
        testId: "live-pages-reactions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NF8X.ReactionsLoader), {
        contentId: contentId,
        location: contentType === 'blogpost' ? (0, $3FlVr.ReactionLocation).BLOGPOST : (0, $3FlVr.ReactionLocation).PAGE,
        containerId: spaceId,
        containerType: (0, $3FlVr.ReactionContainerType).SPACE,
        contentSubType: isLivePage ? (0, $83sfO.LIVE_PAGE_SUBTYPE) : null,
        summaryViewEnabled: true,
        summaryViewThreshold: 1,
        allowSelectFromSummaryView: true,
        useButtonAlignmentStyling: true,
        summaryViewPlacement: "bottom-start",
        hideNoReactionsText: true,
        readOnly: isDisabled,
        isViewOnly: isDisabled,
        isSubtle: true,
        reactionPickerTriggerIcon: customIcon,
        reactionPickerTriggerText: formatMessage($06f66a283e23582e$var$i18n.addNew),
        useDefaultStyledContainer: true,
        hidePlaceholder: isSSR,
        noRelativeContainer: true,
        noFlexWrap: true,
        hoverableSummaryView: true,
        optimisticallyLoadSummaryEmojis: isSSR,
        renderParticleEffectOnSummaryView: true,
        bylineContainerRef: editorBylineContainerRef,
        renderParticleEffectOnLoad: isEligibleReactionsFeedbackPageReturn
    }), isEligibleReactionsFeedbackPageReturn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $06f66a283e23582e$var$dotStyles,
        testId: "reactions-feedback-experiment-live-dot"
    }));
};



var $fImWv = parcelRequire("fImWv");


var $04VgG = parcelRequire("04VgG");





var $5vi32 = parcelRequire("5vi32");








var $a9SX7 = parcelRequire("a9SX7");


var $bQm3c = parcelRequire("bQm3c");








var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $6qdjm = parcelRequire("6qdjm");


var $3gadb = parcelRequire("3gadb");

















var $AavAW = parcelRequire("AavAW");


var $9BupY = parcelRequire("9BupY");

const $dce34ae8b4376c02$var$i18n = (0, $aXWIB.defineMessages)({
    recentFriendlyWhen: {
        id: "content-header.by-line.live-pages.last.updated.friendly.just.now",
        defaultMessage: "Just now"
    },
    tooltipWhen: {
        id: "content-header.by-line.live-pages.last.updated.tooltip",
        defaultMessage: "Last updated: {day} at {time}"
    }
});
const $dce34ae8b4376c02$export$e4a26074619839f4 = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, editorApi: editorApi })=>{
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $9BupY.default), {
        variables: {
            contentId: contentId
        },
        notifyOnNetworkStatusChange: true,
        // sets loading to true when refetching, necessary for tooltip
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network' // query is preloaded on SSR, but not for SPA
    });
    const latestVersion = data?.content?.nodes?.[0]?.version;
    // We need version in a state variable separate from query data, in order to set it on debouncedSetRecentVersion
    const [version, setVersion] = (0, $42omo.useState)({
        friendlyWhen: latestVersion?.friendlyWhen || null,
        when: latestVersion?.when || null
    });
    const previousRemoteChangeTimeRef = (0, $42omo.useRef)(undefined);
    const previousLocalChangeTimeRef = (0, $42omo.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const intl = (0, $aXWIB.useIntl)();
    // Medium dateStyle does not support 'at' combiner, so we're using separate date/time formatters
    const dayFormatter = Intl.DateTimeFormat(locale, {
        dateStyle: 'medium'
    });
    const timeFormatter = Intl.DateTimeFormat(locale, {
        timeStyle: 'short'
    });
    (0, $42omo.useEffect)(()=>{
        // Only show the latest version, which could be from the query or from debouncedSetRecentVersion
        if (latestVersion && JSON.stringify(latestVersion) !== JSON.stringify(version) && latestVersion.when && latestVersion.when >= (version?.when ?? '0')) setVersion({
            friendlyWhen: latestVersion.friendlyWhen ?? null,
            when: latestVersion.when ?? null
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to trigger this on data change
    }, [
        latestVersion
    ]);
    // Fetch that is immediately invoked before the debounced wait period
    // Used on visibility change (when user switches to this tab) and mouseenter
    const debouncedLeadingFetch = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(refetch, 60000, {
            leading: true,
            trailing: false,
            maxWait: 60000
        }), [
        refetch
    ]);
    (0, $42omo.useEffect)(()=>{
        // Fetch last updated time when tab is focused
        const handleVisibilityChange = async ()=>{
            if (document.visibilityState === 'visible') debouncedLeadingFetch(); // Get latest value when user switches back to this tab
        };
        window.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            window.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [
        debouncedLeadingFetch
    ]);
    // After a page edit, we know the last change was very recent, so we directly set the version and skip
    // fetching over the network. We still debounce this to avoid rapid calls and prevent perfromance lag
    // when a user starts typing on very large pages
    const debouncedSetRecentVersion = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setVersion({
                friendlyWhen: intl.formatMessage($dce34ae8b4376c02$var$i18n.recentFriendlyWhen),
                when: new Date().toISOString()
            });
        }, 3000), [
        setVersion,
        intl
    ]);
    // Update time stamp to "Just now" on page edit
    (0, $6qdjm.usePluginStateEffect)(editorApi, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastRemoteChangeTime = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
        const lastLocalChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const hasRemoteChanged = lastRemoteChangeTime && lastRemoteChangeTime !== previousRemoteChangeTimeRef.current;
        const hasLocalChanged = lastLocalChangeTime && lastLocalChangeTime !== previousLocalChangeTimeRef.current;
        if (hasRemoteChanged || hasLocalChanged) {
            previousRemoteChangeTimeRef.current = lastRemoteChangeTime;
            previousLocalChangeTimeRef.current = lastLocalChangeTime;
            debouncedSetRecentVersion();
        }
    });
    // Cancel any pending timers on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            debouncedLeadingFetch.cancel();
            debouncedSetRecentVersion.cancel();
        };
    }, [
        debouncedLeadingFetch,
        debouncedSetRecentVersion
    ]);
    const tooltipContent = (0, $42omo.useMemo)(()=>{
        if (loading) return null;
        else if (version?.when) {
            // When time since last update is > 48 hours ago, friendlyWhen will be a date (i.e. Oct 31, 2024)
            // However, user time zone conversion of the friendlyWhen date is not currently working on the BE,
            // which means the localized date in the tooltip can differ from the UTC date in the byline.
            // To fix this discrepancy, for now we'll not show the tooltip for dates > 48 hours
            const date = new Date(version?.when);
            const twoDaysInMillis = 172800000;
            if (Date.now() - date.getTime() > twoDaysInMillis) return null;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...$dce34ae8b4376c02$var$i18n.tooltipWhen,
                values: {
                    day: dayFormatter.format(date),
                    time: timeFormatter.format(date)
                }
            });
        }
    }, [
        loading,
        version?.when,
        dayFormatter,
        timeFormatter
    ]);
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
        // so returning empty `<ErrorDisplay>` here.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    const handleTooltipShow = ()=>{
        debouncedLeadingFetch();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'LivePagesByLineLastUpdated',
                action: 'displayed',
                actionSubject: 'tooltip',
                actionSubjectId: 'bylineLastUpdate',
                attributes: {
                    contentId: contentId,
                    isLivePage: true
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipContent,
        onShow: handleTooltipShow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $AavAW.ByLineLastUpdatedCompact), {
        version: version,
        loading: loading
    }));
});



var $aKxcs = parcelRequire("aKxcs");


var $6iOCg = parcelRequire("6iOCg");

const $3db5129918072e70$export$a6a69f624b6c8259 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(68);
    const { contentId: contentId, author: author, owner: owner, contributorsCount: contributorsCount, isOwnerContributor: isOwnerContributor, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, generatedBy: generatedBy, isCurrentUserContributor: isCurrentUserContributor, editorBylineContainerRef: t1 } = t0;
    const editorBylineContainerRef = t1 === undefined ? undefined : t1;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { approvalRequest: approvalRequest, availableWorkflowStatuses: availableWorkflowStatuses } = (0, $laFNM.useApprovals)();
    let t2;
    if ($[0] !== approvalRequest || $[1] !== availableWorkflowStatuses) {
        t2 = !!approvalRequest?.application?.workflowStatusId && availableWorkflowStatuses.some((s)=>s.id === approvalRequest.application.workflowStatusId) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[0] = approvalRequest;
        $[1] = availableWorkflowStatuses;
        $[2] = t2;
    } else t2 = $[2];
    const hasActiveWorkflowStatus = t2;
    let t3;
    if ($[3] !== contentId) {
        t3 = {
            contentId: contentId,
            isDraft: true
        };
        $[3] = contentId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t3) {
        t4 = {
            fetchPolicy: "cache-first",
            variables: t3,
            skip: !Boolean(window.__SSR_RENDERED__)
        };
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $6900e8f8fbd4b479$export$2e2bcd8739ae039), t4);
    const contributorCountWithoutOwner = contributorsCount - (isOwnerContributor ? 1 : 0);
    const eligibleForReactions = isEmbeddedConfluence ? hasReactions : true;
    const renderReactions = (isLivePage || !isUnpublishedDraft) && eligibleForReactions;
    const t5 = renderReactions ? undefined : "space.050";
    let t6;
    if ($[7] !== author || $[8] !== contributorCountWithoutOwner || $[9] !== generatedBy || $[10] !== owner) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
            owner: owner,
            author: author,
            analyticsSource: "liveDoc",
            contributorCountWithoutOwner: contributorCountWithoutOwner,
            generatedBy: generatedBy
        });
        $[7] = author;
        $[8] = contributorCountWithoutOwner;
        $[9] = generatedBy;
        $[10] = owner;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t5 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: t5
        }, t6);
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    const singleLineOwnershipByline = t7;
    const showByLineExtensions = isEmbeddedConfluence ? hasByLineExtensions : true;
    let t8;
    if ($[15] !== contentId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aKxcs.BylineClassification), {
            contentId: contentId
        });
        $[15] = contentId;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = [
            (0, $bJX6u.ContentStateStateContainer)
        ];
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== contentId || $[19] !== contentType || $[20] !== data?.singleContent?.contentState || $[21] !== hasActiveWorkflowStatus || $[22] !== isKnowledgeBaseSpace || $[23] !== isLivePage || $[24] !== isPublishingContent || $[25] !== userOffline || $[26] !== viewMode) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t9
        }, (contentStateState)=>{
            if (viewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63EIj.RendererContentState), {
                contentId: contentId,
                hasSeparator: false,
                isDraft: !isLivePage
            });
            const isSSRRenderedOnLoad = Boolean(data?.singleContent?.contentState) && Boolean(window.__SSR_RENDERED__) && contentStateState.state.shouldRunContentStateEffect;
            if (contentStateState.state.contentState || hasActiveWorkflowStatus || isKnowledgeBaseSpace || isSSRRenderedOnLoad || (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkVM2.EditorContentState), {
                contentId: contentId,
                contentType: contentType,
                isPublishingContent: isPublishingContent,
                userOffline: userOffline,
                floatingToolbarButtonStyle: {
                    alignItems: "center",
                    height: "24px"
                },
                isViewMode: viewMode ?? false
            });
            else return null;
        });
        $[18] = contentId;
        $[19] = contentType;
        $[20] = data?.singleContent?.contentState;
        $[21] = hasActiveWorkflowStatus;
        $[22] = isKnowledgeBaseSpace;
        $[23] = isLivePage;
        $[24] = isPublishingContent;
        $[25] = userOffline;
        $[26] = viewMode;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== contentId || $[29] !== editorApi || $[30] !== isLivePage) {
        t11 = isLivePage && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dce34ae8b4376c02$export$e4a26074619839f4), {
            contentId: contentId,
            editorApi: editorApi
        });
        $[28] = contentId;
        $[29] = editorApi;
        $[30] = isLivePage;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== contentId || $[33] !== editorApi) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04VgG.ReadTime), {
            contentId: contentId,
            editorApi: editorApi,
            isInEditor: true
        });
        $[32] = contentId;
        $[33] = editorApi;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== contentId || $[36] !== contentType || $[37] !== isAIEarlyAccessEnabled || $[38] !== isAdminHubAIEnabled) {
        t13 = isAdminHubAIEnabled && (!(0, $6mKj3.isExperimentEnabled)("confluence_audio_labs_lozenge") || isAIEarlyAccessEnabled) && (0, $6mKj3.isExperimentEnabled)("confluence_audio_v3") && (0, $6mKj3.isExperimentEnabled)("confluence_ai_consumption_byline") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a9SX7.ListenByline), {
            contentId: contentId,
            contentType: contentType
        });
        $[35] = contentId;
        $[36] = contentType;
        $[37] = isAIEarlyAccessEnabled;
        $[38] = isAdminHubAIEnabled;
        $[39] = t13;
    } else t13 = $[39];
    let t14;
    if ($[40] !== author || $[41] !== contentId || $[42] !== isLivePage || $[43] !== isUnpublishedDraft) {
        t14 = (isLivePage || !isUnpublishedDraft) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fImWv.AnalyticsByLine), {
            contentId: contentId,
            contentAuthorId: author.userId
        });
        $[40] = author;
        $[41] = contentId;
        $[42] = isLivePage;
        $[43] = isUnpublishedDraft;
        $[44] = t14;
    } else t14 = $[44];
    let t15;
    if ($[45] !== t10 || $[46] !== t11 || $[47] !== t12 || $[48] !== t13 || $[49] !== t14 || $[50] !== t8) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t8, t10, t11, t12, t13, t14);
        $[45] = t10;
        $[46] = t11;
        $[47] = t12;
        $[48] = t13;
        $[49] = t14;
        $[50] = t8;
        $[51] = t15;
    } else t15 = $[51];
    const byLineExtensions = t15;
    const t16 = showByLineExtensions && byLineExtensions;
    let t17;
    if ($[52] !== contentId || $[53] !== contentType || $[54] !== editorBylineContainerRef || $[55] !== isCurrentUserContributor || $[56] !== renderReactions || $[57] !== spaceId || $[58] !== userOffline) {
        t17 = renderReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $06f66a283e23582e$export$37ba4ba009bc421f), {
            contentId: contentId,
            spaceId: spaceId || "",
            isDisabled: userOffline,
            contentType: contentType,
            isCurrentUserContributor: isCurrentUserContributor,
            editorBylineContainerRef: editorBylineContainerRef
        });
        $[52] = contentId;
        $[53] = contentType;
        $[54] = editorBylineContainerRef;
        $[55] = isCurrentUserContributor;
        $[56] = renderReactions;
        $[57] = spaceId;
        $[58] = userOffline;
        $[59] = t17;
    } else t17 = $[59];
    let t18;
    if ($[60] !== t16 || $[61] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t16, t17);
        $[60] = t16;
        $[61] = t17;
        $[62] = t18;
    } else t18 = $[62];
    const ByLineCommonContent = t18;
    const showByLineContributors = isEmbeddedConfluence ? hasByLineContributors : true;
    const t19 = contentType;
    const t20 = showByLineContributors && singleLineOwnershipByline;
    let t21;
    if ($[63] !== ByLineCommonContent || $[64] !== contentId || $[65] !== t19 || $[66] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iOCg.SingleLineByLine), {
            contentId: contentId,
            contentType: t19
        }, t20, ByLineCommonContent);
        $[63] = ByLineCommonContent;
        $[64] = contentId;
        $[65] = t19;
        $[66] = t20;
        $[67] = t21;
    } else t21 = $[67];
    return t21;
});



var $ausiN = parcelRequire("ausiN");


var $83fWZ = parcelRequire("83fWZ");

const $d898e2893b08edbf$export$7ee26dfdd6e2e40f = ({ contentId: contentId, contentType: contentType, viewMode: viewMode, isPublishingContent: isPublishingContent, isKnowledgeBaseSpace: isKnowledgeBaseSpace, userOffline: userOffline, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, editorBylineContainerRef: editorBylineContainerRef })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const lastLoadedQueryData = (0, $42omo.useRef)(null);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // eslint-disable-next-line prefer-const
    let { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $fxLAA.default), {
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // Don't omit versionOverride, embeddedContentRender and limit
            // It's an Apollo bug that if preloader these needs to be match preloaded query
            // Also doesn't work if removing them from preloader variables HOT-109035
            versionOverride: null,
            embeddedContentRender: null,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            ...isUnpublishedDraft && !isLivePage && {
                status: [
                    'draft'
                ]
            }
        },
        context: {
            single: true
        },
        fetchPolicy: 'cache-and-network'
    });
    const renderByLine = ()=>{
        // HACK: status: ['draft'] for unpublished drafts results in a weird case where loading is true and we also have the data. Need to investigate this further, but this hack should work for now.
        // happens because isUnpublishedDraft goes from false to true during SSR. ideally we would either always get the right data, or not need it (pass status: ['draft', 'current'] all the time - which could cause caching issues)
        const hasSSRData = renderServerPlaceholder && Boolean(data);
        if (loading && !hasSSRData) {
            // If we're loading because the LivePagesByLineWithContributorsComponent called our
            // fetchAllContributors, then we should continue the render with data
            // cached from the previous query (the one with the low
            // contributorsFetchLimit). It's important to not bring the skeletons back
            // up, as that'd kill the opening of the dropdown.
            if (lastLoadedQueryData.current) data = lastLoadedQueryData.current;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ausiN.LivePagesByLinePlaceholderComponent), null);
        } else if (!error) lastLoadedQueryData.current = data || null;
        const content = data?.content?.nodes?.[0];
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return null;
            } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
            // so returning empty `<ErrorDisplay>` here.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
        } else if (!content) return null;
        const contributorProps = $d898e2893b08edbf$export$6dbfb663651d0abf(content, data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3db5129918072e70$export$a6a69f624b6c8259), {
            ...contributorProps,
            contentId: contentId,
            contentType: contentType,
            viewMode: viewMode,
            isPublishingContent: isPublishingContent,
            isKnowledgeBaseSpace: isKnowledgeBaseSpace,
            userOffline: userOffline,
            editorApi: editorApi,
            isUnpublishedDraft: isUnpublishedDraft,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            hasReactions: hasReactions,
            editorBylineContainerRef: editorBylineContainerRef
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    }, renderByLine());
};
const $d898e2893b08edbf$export$6dbfb663651d0abf = (content, data)=>{
    const author = (0, $83fWZ.toUserProps)(content?.history?.createdBy);
    const owner = content?.history?.ownedBy && (content?.type === 'page' || content?.type === 'blogpost') ? (0, $83fWZ.toUserProps)(content?.history?.ownedBy) : null;
    const contributorsCount = data?.contentContributors?.count || 0;
    const isOwnerContributor = data?.contentContributors?.isOwnerContributor;
    const generatedBy = content?.contentProperties?.latest?.generatedBy;
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor || false;
    return {
        author: author,
        owner: owner,
        contributorsCount: contributorsCount,
        isOwnerContributor: isOwnerContributor,
        generatedBy: generatedBy,
        isCurrentUserContributor: isCurrentUserContributor
    };
};


const $d54487d18f54cde1$var$EditorByLineWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $d54487d18f54cde1$var$Spacer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $d54487d18f54cde1$var$RightArea = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1tkexy5q _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $d54487d18f54cde1$export$a5fad03eb2e226dc = (t0)=>{
    const $ = (0, $frIzR.c)(31);
    const { contentId: contentId, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, editorAppearanceButton: editorAppearanceButton, isLivePage: isLivePage, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, isSpaceOverview: isSpaceOverview, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const editorBylineContainerRef = (0, $42omo.useRef)(null);
    if (isSpaceOverview) return null;
    if (isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline")) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $6mKj3.expValEquals)("platform_editor_hydratable_ui", "isEnabled", true);
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] !== contentId || $[2] !== contentType || $[3] !== editorApi || $[4] !== hasByLineContributors || $[5] !== hasByLineExtensions || $[6] !== hasReactions || $[7] !== isKnowledgeBaseSpace || $[8] !== isPublishingContent || $[9] !== isUnpublishedDraft || $[10] !== userOffline || $[11] !== viewMode) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d898e2893b08edbf$export$7ee26dfdd6e2e40f), {
                contentId: contentId,
                contentType: contentType,
                isPublishingContent: isPublishingContent,
                userOffline: userOffline,
                isKnowledgeBaseSpace: isKnowledgeBaseSpace,
                viewMode: viewMode,
                editorApi: editorApi,
                isUnpublishedDraft: isUnpublishedDraft,
                hasByLineContributors: hasByLineContributors,
                hasByLineExtensions: hasByLineExtensions,
                hasReactions: hasReactions,
                editorBylineContainerRef: editorBylineContainerRef
            });
            $[1] = contentId;
            $[2] = contentType;
            $[3] = editorApi;
            $[4] = hasByLineContributors;
            $[5] = hasByLineExtensions;
            $[6] = hasReactions;
            $[7] = isKnowledgeBaseSpace;
            $[8] = isPublishingContent;
            $[9] = isUnpublishedDraft;
            $[10] = userOffline;
            $[11] = viewMode;
            $[12] = t2;
        } else t2 = $[12];
        let t3;
        if ($[13] !== ssrPlaceholderIdProp || $[14] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
                name: "editor-byline",
                enabled: t1
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
                "data-vc": "editor-byline-wrapper",
                ...ssrPlaceholderIdProp,
                ref: editorBylineContainerRef
            }, t2));
            $[13] = ssrPlaceholderIdProp;
            $[14] = t2;
            $[15] = t3;
        } else t3 = $[15];
        return t3;
    }
    let t1;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $6mKj3.expValEquals)("platform_editor_hydratable_ui", "isEnabled", true);
        $[16] = t1;
    } else t1 = $[16];
    let t2;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$Spacer, null);
        $[17] = t2;
    } else t2 = $[17];
    let t3;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $bJX6u.ContentStateStateContainer)
        ];
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== contentId || $[20] !== contentType || $[21] !== isKnowledgeBaseSpace || $[22] !== isPublishingContent || $[23] !== userOffline) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t3
        }, (contentStateState)=>(contentStateState.state.contentState || isKnowledgeBaseSpace || (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkVM2.EditorContentState), {
                contentId: contentId,
                contentType: contentType,
                isPublishingContent: isPublishingContent,
                userOffline: userOffline,
                isViewMode: false
            }));
        $[19] = contentId;
        $[20] = contentType;
        $[21] = isKnowledgeBaseSpace;
        $[22] = isPublishingContent;
        $[23] = userOffline;
        $[24] = t4;
    } else t4 = $[24];
    let t5;
    if ($[25] !== editorAppearanceButton || $[26] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$RightArea, {
            "data-testId": "editor-byline-right-area"
        }, t4, editorAppearanceButton));
        $[25] = editorAppearanceButton;
        $[26] = t4;
        $[27] = t5;
    } else t5 = $[27];
    let t6;
    if ($[28] !== ssrPlaceholderIdProp || $[29] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
            name: "editor-byline",
            enabled: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
            "data-vc": "editor-byline-wrapper",
            ...ssrPlaceholderIdProp
        }, t5));
        $[28] = ssrPlaceholderIdProp;
        $[29] = t5;
        $[30] = t6;
    } else t6 = $[30];
    return t6;
};
module.exports["EditorByLineArea"] = $d54487d18f54cde1$export$a5fad03eb2e226dc;

});

parcelRegister("jkVM2", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5f9bfd31a6a2d08f$export$2791e79b1a186ba4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CFAQV",
    name: "EditorContentState",
    loader: async ()=>(await (parcelRequire("1UR8Z"))).EditorContentState
});
module.exports["EditorContentState"] = $5f9bfd31a6a2d08f$export$2791e79b1a186ba4;

});

parcelRegister("1UR8Z", function(module, exports) {

let $16543eb23e3ce776$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $16543eb23e3ce776$var$load("6m3ID"),
    $16543eb23e3ce776$var$load("6jGZ7"),
    $16543eb23e3ce776$var$load("hhss7"),
    $16543eb23e3ce776$var$load("ljCe8")
]).then(()=>parcelRequire('iDxDj'));

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("63EIj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36c7522a305dc07d$export$cbe74da24be93fbd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lwzlE",
    name: "RendererContentState",
    loader: async ()=>(await (parcelRequire("7NNvk"))).RendererContentState
});
module.exports["RendererContentState"] = $36c7522a305dc07d$export$cbe74da24be93fbd;

});

parcelRegister("7NNvk", function(module, exports) {

let $5ae3828cd5594aab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5ae3828cd5594aab$var$load("9opeZ").then(()=>parcelRequire('44FvL'));

});

parcelRegister("83sfO", function(module, exports) {
const $567f280605647fdf$export$5d4c19aec4201e9 = 'live';
module.exports["LIVE_PAGE_SUBTYPE"] = $567f280605647fdf$export$5d4c19aec4201e9;

});

parcelRegister("04VgG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $47a3fe800ce35819$export$77dedcd16f070a20 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7obd3",
    name: "ReadTime",
    loader: async ()=>(await (parcelRequire("x3fqJ"))).ReadTime
});
module.exports["ReadTime"] = $47a3fe800ce35819$export$77dedcd16f070a20;

});

parcelRegister("x3fqJ", function(module, exports) {

let $06359a247ac58c99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $06359a247ac58c99$var$load("irgIM").then(()=>parcelRequire('cbZqw'));

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $g5QRf = parcelRequire("g5QRf");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t2 = emoji || "";
        let t3;
        if ($[0] !== height || $[1] !== t2 || $[2] !== type) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t2,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t2;
            $[2] = type;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions.liveDoc : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t2;
    if ($[4] !== Icon || $[5] !== color || $[6] !== label.id) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[4] = Icon;
        $[5] = color;
        $[6] = label.id;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16 })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions['liveDoc'] : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $aXWIB.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("hkzol", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $1bY7o = parcelRequire("1bY7o");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $3gadb = parcelRequire("3gadb");


var $6F6hl = parcelRequire("6F6hl");


var $56QzY = parcelRequire("56QzY");


var $6abPE = parcelRequire("6abPE");


var $jooGc = parcelRequire("jooGc");


var $kfIha = parcelRequire("kfIha");

const $5e3895b62fe84f52$var$i18n = (0, $aXWIB.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "copy-content-link.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "copy-content-link.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY = 100;
const $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT = 2500;
const $5e3895b62fe84f52$var$iconButtonAppearances = new Set([
    'default',
    'primary',
    'discovery',
    'subtle'
]);
const $5e3895b62fe84f52$var$formatIconButtonAppearance = (appearance)=>$5e3895b62fe84f52$var$iconButtonAppearances.has(appearance) ? appearance : 'default';
const $5e3895b62fe84f52$export$9957974f8b4d8f74 = 'copyShareLink';
const $5e3895b62fe84f52$export$534d10f1c5b9c7b3 = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, isDraft: isDraft = false, isLivePage: isLivePage = false, isDisabled: isDisabled = false, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom', buttonText: buttonText = '', copiedTextTooltipLabel: copiedTextTooltipLabel = $5e3895b62fe84f52$var$i18n.copiedTextLabel, onClickAttributes: onClickAttributes, iconColor: iconColor, urlOverride: urlOverride = '' })=>{
    const intl = (0, $aXWIB.useIntl)();
    const cleanupCopiedTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isCopied, setIsCopied] = (0, $42omo.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $42omo.useState)();
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    // Hook to store copy content link click state
    const { setHasClickedCopyContentLink: setHasClickedCopyContentLink, resetHasClickedCopyContentLink: resetHasClickedCopyContentLink } = (0, $jooGc.useCopyContentLinkActions)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    (0, $42omo.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $42omo.useEffect)(()=>{
        resetHasClickedCopyContentLink();
    }, [
        resetHasClickedCopyContentLink
    ]);
    const { unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $6abPE.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source,
        skip: Boolean(urlOverride)
    });
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e3895b62fe84f52$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $56QzY.END),
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    ...onClickAttributes ?? {}
                }
            }
        }).fire();
        //mark has copy content link click to true
        setHasClickedCopyContentLink();
        try {
            if (!urlOverride) await copyContentLink();
            else await copyToClipboard(urlOverride);
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e3895b62fe84f52$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e3895b62fe84f52$var$i18n.errorCopyingTextLabel : copiedTextTooltipLabel);
    const onMouseLeave = ()=>{
        if (shouldResetOnHover) setIsCopied(false);
    };
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        isCopied
    ]);
    const iconButtonAppearance = $5e3895b62fe84f52$var$formatIconButtonAppearance(buttonAppearance);
    const getCopyButton = ()=>buttonText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            testId: "copy-link-button",
            "aria-label": copyLinkText,
            appearance: buttonAppearance,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled
        }, buttonText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "copy-link-button",
            label: copyLinkText,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                    ...iconProps,
                    color: iconColor
                }),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled,
            appearance: iconButtonAppearance
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, isCopied && confirmationText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            if (isCopied) return confirmationText;
            if (buttonText) return buttonText;
            else return copyLinkText;
        },
        position: tooltipPosition,
        ignoreTooltipPointerEvents: true,
        delay: $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY
    }, getCopyButton()));
};
module.exports["ACTION_SUBJECT_ID"] = $5e3895b62fe84f52$export$9957974f8b4d8f74;
module.exports["CopyLinkButton"] = $5e3895b62fe84f52$export$534d10f1c5b9c7b3;

});

parcelRegister("6abPE", function(module, exports) {

var $2i78V = parcelRequire("2i78V");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $9wGTI = parcelRequire("9wGTI");


var $hkzol = parcelRequire("hkzol");


var $kfIha = parcelRequire("kfIha");

const $68bb0af1984f782c$var$useCopyContentLinkQuery = (0, $2i78V.default);
const $68bb0af1984f782c$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, skip: skip = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $42omo.useState)();
    const { toUrl: toUrl } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($68bb0af1984f782c$var$useCopyContentLinkQuery, {
        variables: {
            contentId: contentId || ''
        },
        skip: !contentId || skip
    });
    const makeContentLink = (0, $42omo.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === 'edit') copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) {
                const copyLinkUrl = `${links.base}${copyLink}`;
                return copyLinkUrl;
            }
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === 'edit') {
            routeName = contentType === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === 'blogpost' ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case 'overview':
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case 'blogpost':
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case 'page':
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case 'whiteboard':
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case 'slide':
                routeName = (0, $1NBp8.SLIDES_VIEW).name;
                break;
            // omit databases and other unsupported content types
            default:
                if (!contentType && (0, $9wGTI.fg)('confluence_ufo_trace_ct_err')) // contentType is undefined/empty - this is a data issue, not a
                // truly unsupported type. Return undefined rather than erroring.
                return undefined;
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'generated',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            const copyLinkUrl = `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
            return copyLinkUrl;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $42omo.useCallback)(()=>{
        return copyToClipboard(makeContentLink());
    }, [
        makeContentLink,
        copyToClipboard
    ]);
    return {
        queryError: queryError,
        unsupportedLinkError: unsupportedLinkError,
        makeContentLink: makeContentLink,
        copyContentLink: copyContentLink
    };
};
module.exports["useCopyContentLink"] = $68bb0af1984f782c$export$a049904f049cf16d;

});

parcelRegister("2i78V", function(module, exports) {
/**
 * @generated SignedSource<<76594ff6dea3ddce980da6a08753a006>>
 * @relayHash 29cac5aad51907935410d62eca7f1996
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34
const $77e7fa3fd8a73973$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tinyui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "base"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "29cac5aad51907935410d62eca7f1996",
            "id": "9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34",
            "metadata": {},
            "name": "useCopyContentLinkQuery",
            "operationKind": "query",
            "text": "query useCopyContentLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
        }
    };
}();
$77e7fa3fd8a73973$var$node.hash = "37d735340f7b52ac7552b4a67a3fb5da";
var $77e7fa3fd8a73973$export$2e2bcd8739ae039 = $77e7fa3fd8a73973$var$node;
module.exports["default"] = $77e7fa3fd8a73973$export$2e2bcd8739ae039;

});

parcelRegister("jooGc", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4ca5e403580d1e7d$var$initialState = {
    hasClickedCopyContentLink: false
};
const $4ca5e403580d1e7d$var$actions = {
    setHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: true
            });
        },
    resetHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: false
            });
        }
};
const $4ca5e403580d1e7d$var$CopyContentLinkStore = (0, $1P1Tu.createStore)({
    initialState: $4ca5e403580d1e7d$var$initialState,
    actions: $4ca5e403580d1e7d$var$actions,
    name: 'CopyContentLinkStore'
});
const $4ca5e403580d1e7d$export$77cd2a2387f7879a = (0, $9zUhf.createStateHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
const $4ca5e403580d1e7d$export$c42bcb6cac241c15 = (0, $9zUhf.createActionsHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
module.exports["useCopyContentLinkActions"] = $4ca5e403580d1e7d$export$c42bcb6cac241c15;

});

parcelRegister("i28ZW", function(module, exports) {

var $i0mmi = parcelRequire("i0mmi");


var $42omo = parcelRequire("42omo");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iquRY = parcelRequire("iquRY");


var $jMyy4 = parcelRequire("jMyy4");

const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $i0mmi.default);
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$d9a801072630763d = 'manage_templates';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$a89133b28496ff30 = 'manage_look_and_feel';
const $981a614bc39b93a3$export$50faaafd42078ad9 = 'manage_content';
const $981a614bc39b93a3$export$a7c1ec142e70d69d = 'archive';
const $981a614bc39b93a3$export$92f9e1ed9114d3a6 = 'copy';
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey, skip: skip })=>{
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const defaultSkip = !spaceKey || !isRbacEnabled;
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip !== undefined ? skip : defaultSkip,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        }
    });
    const hasSpaceOperation = (0, $42omo.useCallback)((spaceOperation)=>{
        return data?.space?.operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
    }, [
        data
    ]);
    return {
        canManageSomeUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4) || hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149) || hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: hasSpaceOperation($981a614bc39b93a3$export$fae9e1a00840692e),
        canManageTemplates: hasSpaceOperation($981a614bc39b93a3$export$d9a801072630763d),
        canManageLookAndFeel: hasSpaceOperation($981a614bc39b93a3$export$a89133b28496ff30),
        canAdminister: hasSpaceOperation($981a614bc39b93a3$export$80ed1bd55ccf4772),
        canManageContent: hasSpaceOperation($981a614bc39b93a3$export$50faaafd42078ad9),
        canArchive: hasSpaceOperation($981a614bc39b93a3$export$a7c1ec142e70d69d),
        canCopy: hasSpaceOperation($981a614bc39b93a3$export$92f9e1ed9114d3a6),
        loading: loading || isLoadingSpaceRoleMode
    };
};
module.exports["useSpaceManagementOperations"] = $981a614bc39b93a3$export$f8731d5631669ee8;

});

parcelRegister("i0mmi", function(module, exports) {
/**
 * @generated SignedSource<<538ddf86109b083feb03880ace3dfe2d>>
 * @relayHash 0a3dc9cecca8233daf01e0443fdaa5e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471
const $7dc84e66153faa36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0a3dc9cecca8233daf01e0443fdaa5e6",
            "id": "1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471",
            "metadata": {},
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "operationKind": "query",
            "text": "query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin},operations{operation,targetType}}}"
        }
    };
}();
$7dc84e66153faa36$var$node.hash = "4d967e32f567d3367490b1d8fb6f1ecf";
var $7dc84e66153faa36$export$2e2bcd8739ae039 = $7dc84e66153faa36$var$node;
module.exports["default"] = $7dc84e66153faa36$export$2e2bcd8739ae039;

});

parcelRegister("erzVD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0c6da6b618ff535$export$44ec82a0a8c60a0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xpRfQ",
    name: "InspectPermissionsDialog",
    loader: async ()=>(await (parcelRequire("h71c3"))).InspectPermissionsDialog
});
module.exports["InspectPermissionsDialog"] = $d0c6da6b618ff535$export$44ec82a0a8c60a0e;

});

parcelRegister("h71c3", function(module, exports) {

let $c7540414e914bd3d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c7540414e914bd3d$var$load("9hYRW"),
    $c7540414e914bd3d$var$load("kpm7S"),
    $c7540414e914bd3d$var$load("jDjSj"),
    $c7540414e914bd3d$var$load("6wr18"),
    $c7540414e914bd3d$var$load("dMOc8"),
    $c7540414e914bd3d$var$load("eYCHi"),
    $c7540414e914bd3d$var$load("7o5Pu"),
    $c7540414e914bd3d$var$load("c831e"),
    $c7540414e914bd3d$var$load("1H5IN"),
    $c7540414e914bd3d$var$load("jbmut"),
    $c7540414e914bd3d$var$load("h4Nf7"),
    $c7540414e914bd3d$var$load("7do1E"),
    $c7540414e914bd3d$var$load("77dkW"),
    $c7540414e914bd3d$var$load("Wowvf"),
    $c7540414e914bd3d$var$load("kHOMt"),
    $c7540414e914bd3d$var$load("9AXkC"),
    $c7540414e914bd3d$var$load("ffEVr"),
    $c7540414e914bd3d$var$load("7EorR"),
    $c7540414e914bd3d$var$load("28arV"),
    $c7540414e914bd3d$var$load("hhss7"),
    $c7540414e914bd3d$var$load("31vk5"),
    $c7540414e914bd3d$var$load("85liN")
]).then(()=>parcelRequire('jl66H'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("gqypm", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip
    });
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("lOI2p", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $d8ad782c0a3406d7$export$8cca2d6324f11821 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { onClose: onClose, popupRef: popupRef, triggerRef: triggerRef } = t0;
    let t1;
    let t2;
    if ($[0] !== onClose || $[1] !== popupRef || $[2] !== triggerRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const keyDownEvent = (t3)=>{
                const { key: key } = t3;
                if (key === "Escape" || key === "Esc") onClose();
            };
            const clickEvent = (event)=>{
                if (!document.body.contains(event.target)) return;
                if (popupRef && popupRef.contains(event.target)) return;
                if (triggerRef && triggerRef.contains(event.target)) return;
                if (event.target.closest(".atlaskit-portal-container [role=dialog]")) return;
                onClose();
            };
            window.addEventListener("click", clickEvent);
            window.addEventListener("keydown", keyDownEvent);
            return ()=>{
                window.removeEventListener("click", clickEvent);
                window.removeEventListener("keydown", keyDownEvent);
            };
        };
        t2 = [
            popupRef,
            triggerRef,
            onClose
        ];
        $[0] = onClose;
        $[1] = popupRef;
        $[2] = triggerRef;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
} : ({ onClose: onClose, popupRef: popupRef, triggerRef: triggerRef })=>{
    (0, $42omo.useEffect)(()=>{
        if (!popupRef) return;
        const keyDownEvent = ({ key: key })=>{
            if (key === 'Escape' || key === 'Esc') onClose();
        };
        const clickEvent = (event)=>{
            // Refresh button inside Forge app triggers earlier then clickEvent
            // Forge App starts update and popup does not have event.target anymore
            if (!document.body.contains(event.target)) return;
            // Do not close if interaction was performed on the current popup
            if (popupRef && popupRef.contains(event.target)) return;
            // Do not close if interaction was performed on the trigger container
            if (triggerRef && triggerRef.contains(event.target)) return;
            // Do not close if interaction was performed on the ModalDialog with an error
            if (event.target.closest('.atlaskit-portal-container [role=dialog]')) return;
            onClose();
        };
        window.addEventListener('click', clickEvent);
        window.addEventListener('keydown', keyDownEvent);
        return ()=>{
            window.removeEventListener('click', clickEvent);
            window.removeEventListener('keydown', keyDownEvent);
        };
    }, [
        popupRef,
        triggerRef,
        onClose
    ]);
};
module.exports["useInlineDialogCloseManager"] = $d8ad782c0a3406d7$export$8cca2d6324f11821;

});

parcelRegister("jYZsR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $0b4c17fd4adf87fd$export$de5a461d22cbfa90 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { onUpdate: onUpdate, popupRef: popupRef, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== onUpdate || $[1] !== popupRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onUpdate, 100);
            const observer = new ResizeObserver(()=>{
                updateWithDelay();
            });
            observer.observe(popupRef);
            return ()=>{
                observer.disconnect();
            };
        };
        t2 = [
            popupRef,
            onUpdate
        ];
        $[0] = onUpdate;
        $[1] = popupRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
        $[4] = children;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ onUpdate: onUpdate, popupRef: popupRef, children: children })=>{
    (0, $42omo.useEffect)(()=>{
        if (!popupRef) return;
        const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onUpdate, 100);
        // Workaround to update popup position (by using scheduleUpdate function)
        // on any Forge App resize
        const observer = new ResizeObserver(()=>{
            updateWithDelay();
        });
        observer.observe(popupRef);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupRef,
        onUpdate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
};
module.exports["ResizeChangeListener"] = $0b4c17fd4adf87fd$export$de5a461d22cbfa90;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $aXWIB = parcelRequire("aXWIB");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $dTb09 = parcelRequire("dTb09");


var $7zIsq = parcelRequire("7zIsq");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== locale || $[3] !== moduleType || $[4] !== queryOptions || $[5] !== returnBlockedExtensions || $[6] !== skipQuery || $[7] !== spaceContextOnly || $[8] !== spaceKey) {
        t3 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = locale;
        $[3] = moduleType;
        $[4] = queryOptions;
        $[5] = returnBlockedExtensions;
        $[6] = skipQuery;
        $[7] = spaceContextOnly;
        $[8] = spaceKey;
        $[9] = t3;
    } else t3 = $[9];
    const options = t3;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t4;
    let t5;
    if ($[10] !== extsError || $[11] !== spaceError) {
        t4 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t5 = [
            extsError,
            spaceError
        ];
        $[10] = extsError;
        $[11] = spaceError;
        $[12] = t4;
        $[13] = t5;
    } else {
        t4 = $[12];
        t5 = $[13];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[14] !== extsData || $[15] !== extsError || $[16] !== extsLoading) {
        t6 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[14] = extsData;
        $[15] = extsError;
        $[16] = extsLoading;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $dTb09.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $7zIsq.usePrefilteredExtensionListRelay), (0, $7zIsq.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, spaceContextOnly: spaceContextOnly = false })=>{
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: spaceContextOnly ? {
            spaceKey: spaceKey
        } : {
            spaceKey: spaceKey,
            contentId: contentId
        },
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("kxhju", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iEfsZ = parcelRequire("iEfsZ");


var $42omo = parcelRequire("42omo");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $42omo.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("1gjU5", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw1qyo _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("4vC63", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { module: module, tooltip: t1, children: children } = t0;
    const tooltip = t1 === undefined ? "" : t1;
    let accelerator;
    let t2;
    if ($[0] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t2 = accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = module;
        $[1] = accelerator;
        $[2] = t2;
    } else {
        accelerator = $[1];
        t2 = $[2];
    }
    if (t2) {
        const t3 = `forge-keyboard-shortcut-visualizer-${accelerator}`;
        let t4;
        if ($[3] !== accelerator || $[4] !== tooltip) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: accelerator,
                contentBefore: tooltip,
                isTooltip: true
            });
            $[3] = accelerator;
            $[4] = tooltip;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== children || $[7] !== t3 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                tag: "span",
                testId: t3,
                content: t4
            }, children);
            $[6] = children;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t3;
    if ($[10] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[10] = children;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { module: module, action: action } = t0;
    let accelerator;
    let t1;
    if ($[0] !== action || $[1] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t1 = accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = action;
        $[1] = module;
        $[2] = accelerator;
        $[3] = t1;
    } else {
        accelerator = $[2];
        t1 = $[3];
    }
    if (t1) {
        const t2 = `forge-keyboard-shortcut-${accelerator}`;
        let t3;
        if ($[4] !== accelerator || $[5] !== action) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                accelerator: accelerator,
                listener: action,
                shortcutType: (0, $bflGB.ShortcutType).Forge
            });
            $[4] = accelerator;
            $[5] = action;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": t2
            }, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    return null;
} : ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("lXnaE"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("4EDQB"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("63Sa6"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("KFpBB"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("4e9mM"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("gcnRn"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("i52gf"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("4doEc"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("kFJwL"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("5shOo"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("3Hycf"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("5S3Gg"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("lXnaE", function(module, exports) {

let $ffc114e09dca3abb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffc114e09dca3abb$var$load("2YffH"),
    $ffc114e09dca3abb$var$load("1o23t"),
    $ffc114e09dca3abb$var$load("b7OPx"),
    $ffc114e09dca3abb$var$load("lqFMg"),
    $ffc114e09dca3abb$var$load("gELW6"),
    $ffc114e09dca3abb$var$load("4hDGB"),
    $ffc114e09dca3abb$var$load("7o5Pu"),
    $ffc114e09dca3abb$var$load("1H5IN"),
    $ffc114e09dca3abb$var$load("eBRUf"),
    $ffc114e09dca3abb$var$load("hwT9D"),
    $ffc114e09dca3abb$var$load("j4Bpe"),
    $ffc114e09dca3abb$var$load("h4Nf7"),
    $ffc114e09dca3abb$var$load("7f9Fz"),
    $ffc114e09dca3abb$var$load("8YSo7"),
    $ffc114e09dca3abb$var$load("7do1E"),
    $ffc114e09dca3abb$var$load("77dkW"),
    $ffc114e09dca3abb$var$load("g9CVe"),
    $ffc114e09dca3abb$var$load("9hYRW"),
    $ffc114e09dca3abb$var$load("kpm7S"),
    $ffc114e09dca3abb$var$load("6wr18"),
    $ffc114e09dca3abb$var$load("kjZZD"),
    $ffc114e09dca3abb$var$load("3JSgG"),
    $ffc114e09dca3abb$var$load("9AXkC"),
    $ffc114e09dca3abb$var$load("ffEVr"),
    $ffc114e09dca3abb$var$load("28arV"),
    $ffc114e09dca3abb$var$load("l1BQC"),
    $ffc114e09dca3abb$var$load("jlSF3"),
    $ffc114e09dca3abb$var$load("2vAWg"),
    $ffc114e09dca3abb$var$load("7cABH"),
    $ffc114e09dca3abb$var$load("31vk5"),
    $ffc114e09dca3abb$var$load("4pqtR"),
    $ffc114e09dca3abb$var$load("5XqRg"),
    $ffc114e09dca3abb$var$load("2uVTT"),
    $ffc114e09dca3abb$var$load("hhss7"),
    $ffc114e09dca3abb$var$load("Wowvf"),
    $ffc114e09dca3abb$var$load("5RR9C"),
    $ffc114e09dca3abb$var$load("2PePB"),
    $ffc114e09dca3abb$var$load("bIPPg"),
    $ffc114e09dca3abb$var$load("lnKog"),
    $ffc114e09dca3abb$var$load("h3ABO"),
    $ffc114e09dca3abb$var$load("kC80R"),
    $ffc114e09dca3abb$var$load("7EorR"),
    $ffc114e09dca3abb$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("4EDQB", function(module, exports) {

let $3639ceb76464ee37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3639ceb76464ee37$var$load("2YffH"),
    $3639ceb76464ee37$var$load("1o23t"),
    $3639ceb76464ee37$var$load("b7OPx"),
    $3639ceb76464ee37$var$load("lqFMg"),
    $3639ceb76464ee37$var$load("gELW6"),
    $3639ceb76464ee37$var$load("4hDGB"),
    $3639ceb76464ee37$var$load("7o5Pu"),
    $3639ceb76464ee37$var$load("1H5IN"),
    $3639ceb76464ee37$var$load("eBRUf"),
    $3639ceb76464ee37$var$load("hwT9D"),
    $3639ceb76464ee37$var$load("j4Bpe"),
    $3639ceb76464ee37$var$load("h4Nf7"),
    $3639ceb76464ee37$var$load("7f9Fz"),
    $3639ceb76464ee37$var$load("8YSo7"),
    $3639ceb76464ee37$var$load("7do1E"),
    $3639ceb76464ee37$var$load("77dkW"),
    $3639ceb76464ee37$var$load("g9CVe"),
    $3639ceb76464ee37$var$load("9hYRW"),
    $3639ceb76464ee37$var$load("kpm7S"),
    $3639ceb76464ee37$var$load("6wr18"),
    $3639ceb76464ee37$var$load("kjZZD"),
    $3639ceb76464ee37$var$load("3JSgG"),
    $3639ceb76464ee37$var$load("9AXkC"),
    $3639ceb76464ee37$var$load("ffEVr"),
    $3639ceb76464ee37$var$load("28arV"),
    $3639ceb76464ee37$var$load("l1BQC"),
    $3639ceb76464ee37$var$load("jlSF3"),
    $3639ceb76464ee37$var$load("2vAWg"),
    $3639ceb76464ee37$var$load("7cABH"),
    $3639ceb76464ee37$var$load("31vk5"),
    $3639ceb76464ee37$var$load("4pqtR"),
    $3639ceb76464ee37$var$load("5XqRg"),
    $3639ceb76464ee37$var$load("2uVTT"),
    $3639ceb76464ee37$var$load("hhss7"),
    $3639ceb76464ee37$var$load("Wowvf"),
    $3639ceb76464ee37$var$load("5RR9C"),
    $3639ceb76464ee37$var$load("2PePB"),
    $3639ceb76464ee37$var$load("bIPPg"),
    $3639ceb76464ee37$var$load("lnKog"),
    $3639ceb76464ee37$var$load("h3ABO"),
    $3639ceb76464ee37$var$load("kC80R"),
    $3639ceb76464ee37$var$load("7EorR"),
    $3639ceb76464ee37$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("63Sa6", function(module, exports) {

let $469d0953f050b025$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $469d0953f050b025$var$load("2YffH"),
    $469d0953f050b025$var$load("1o23t"),
    $469d0953f050b025$var$load("b7OPx"),
    $469d0953f050b025$var$load("lqFMg"),
    $469d0953f050b025$var$load("gELW6"),
    $469d0953f050b025$var$load("4hDGB"),
    $469d0953f050b025$var$load("7o5Pu"),
    $469d0953f050b025$var$load("1H5IN"),
    $469d0953f050b025$var$load("eBRUf"),
    $469d0953f050b025$var$load("hwT9D"),
    $469d0953f050b025$var$load("j4Bpe"),
    $469d0953f050b025$var$load("h4Nf7"),
    $469d0953f050b025$var$load("7f9Fz"),
    $469d0953f050b025$var$load("8YSo7"),
    $469d0953f050b025$var$load("7do1E"),
    $469d0953f050b025$var$load("77dkW"),
    $469d0953f050b025$var$load("g9CVe"),
    $469d0953f050b025$var$load("9hYRW"),
    $469d0953f050b025$var$load("kpm7S"),
    $469d0953f050b025$var$load("6wr18"),
    $469d0953f050b025$var$load("kjZZD"),
    $469d0953f050b025$var$load("3JSgG"),
    $469d0953f050b025$var$load("9AXkC"),
    $469d0953f050b025$var$load("ffEVr"),
    $469d0953f050b025$var$load("28arV"),
    $469d0953f050b025$var$load("l1BQC"),
    $469d0953f050b025$var$load("jlSF3"),
    $469d0953f050b025$var$load("2vAWg"),
    $469d0953f050b025$var$load("7cABH"),
    $469d0953f050b025$var$load("31vk5"),
    $469d0953f050b025$var$load("4pqtR"),
    $469d0953f050b025$var$load("5XqRg"),
    $469d0953f050b025$var$load("2uVTT"),
    $469d0953f050b025$var$load("hhss7"),
    $469d0953f050b025$var$load("Wowvf"),
    $469d0953f050b025$var$load("5RR9C"),
    $469d0953f050b025$var$load("2PePB"),
    $469d0953f050b025$var$load("bIPPg"),
    $469d0953f050b025$var$load("lnKog"),
    $469d0953f050b025$var$load("h3ABO"),
    $469d0953f050b025$var$load("kC80R"),
    $469d0953f050b025$var$load("7EorR"),
    $469d0953f050b025$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("KFpBB", function(module, exports) {

let $08c46b8d298251cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $08c46b8d298251cc$var$load("7do1E"),
    $08c46b8d298251cc$var$load("77dkW"),
    $08c46b8d298251cc$var$load("2YffH"),
    $08c46b8d298251cc$var$load("b7OPx"),
    $08c46b8d298251cc$var$load("lqFMg"),
    $08c46b8d298251cc$var$load("gELW6"),
    $08c46b8d298251cc$var$load("4hDGB"),
    $08c46b8d298251cc$var$load("2PePB"),
    $08c46b8d298251cc$var$load("eBRUf"),
    $08c46b8d298251cc$var$load("hwT9D"),
    $08c46b8d298251cc$var$load("j4Bpe"),
    $08c46b8d298251cc$var$load("h4Nf7"),
    $08c46b8d298251cc$var$load("7f9Fz"),
    $08c46b8d298251cc$var$load("8YSo7"),
    $08c46b8d298251cc$var$load("g9CVe"),
    $08c46b8d298251cc$var$load("9hYRW"),
    $08c46b8d298251cc$var$load("kpm7S"),
    $08c46b8d298251cc$var$load("6wr18"),
    $08c46b8d298251cc$var$load("kjZZD"),
    $08c46b8d298251cc$var$load("3JSgG"),
    $08c46b8d298251cc$var$load("9AXkC"),
    $08c46b8d298251cc$var$load("ffEVr"),
    $08c46b8d298251cc$var$load("28arV"),
    $08c46b8d298251cc$var$load("l1BQC"),
    $08c46b8d298251cc$var$load("jlSF3"),
    $08c46b8d298251cc$var$load("2vAWg"),
    $08c46b8d298251cc$var$load("7cABH"),
    $08c46b8d298251cc$var$load("31vk5"),
    $08c46b8d298251cc$var$load("4pqtR"),
    $08c46b8d298251cc$var$load("5XqRg"),
    $08c46b8d298251cc$var$load("bIPPg"),
    $08c46b8d298251cc$var$load("2uVTT"),
    $08c46b8d298251cc$var$load("hhss7"),
    $08c46b8d298251cc$var$load("Wowvf"),
    $08c46b8d298251cc$var$load("5RR9C"),
    $08c46b8d298251cc$var$load("h3ABO"),
    $08c46b8d298251cc$var$load("kC80R"),
    $08c46b8d298251cc$var$load("7EorR"),
    $08c46b8d298251cc$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("4e9mM", function(module, exports) {

let $313fbc2f3844e0dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $313fbc2f3844e0dc$var$load("7do1E"),
    $313fbc2f3844e0dc$var$load("77dkW"),
    $313fbc2f3844e0dc$var$load("2YffH"),
    $313fbc2f3844e0dc$var$load("b7OPx"),
    $313fbc2f3844e0dc$var$load("lqFMg"),
    $313fbc2f3844e0dc$var$load("gELW6"),
    $313fbc2f3844e0dc$var$load("4hDGB"),
    $313fbc2f3844e0dc$var$load("2PePB"),
    $313fbc2f3844e0dc$var$load("eBRUf"),
    $313fbc2f3844e0dc$var$load("hwT9D"),
    $313fbc2f3844e0dc$var$load("j4Bpe"),
    $313fbc2f3844e0dc$var$load("h4Nf7"),
    $313fbc2f3844e0dc$var$load("7f9Fz"),
    $313fbc2f3844e0dc$var$load("8YSo7"),
    $313fbc2f3844e0dc$var$load("g9CVe"),
    $313fbc2f3844e0dc$var$load("9hYRW"),
    $313fbc2f3844e0dc$var$load("kpm7S"),
    $313fbc2f3844e0dc$var$load("6wr18"),
    $313fbc2f3844e0dc$var$load("kjZZD"),
    $313fbc2f3844e0dc$var$load("3JSgG"),
    $313fbc2f3844e0dc$var$load("9AXkC"),
    $313fbc2f3844e0dc$var$load("ffEVr"),
    $313fbc2f3844e0dc$var$load("28arV"),
    $313fbc2f3844e0dc$var$load("l1BQC"),
    $313fbc2f3844e0dc$var$load("jlSF3"),
    $313fbc2f3844e0dc$var$load("2vAWg"),
    $313fbc2f3844e0dc$var$load("7cABH"),
    $313fbc2f3844e0dc$var$load("31vk5"),
    $313fbc2f3844e0dc$var$load("4pqtR"),
    $313fbc2f3844e0dc$var$load("5XqRg"),
    $313fbc2f3844e0dc$var$load("bIPPg"),
    $313fbc2f3844e0dc$var$load("2uVTT"),
    $313fbc2f3844e0dc$var$load("hhss7"),
    $313fbc2f3844e0dc$var$load("Wowvf"),
    $313fbc2f3844e0dc$var$load("5RR9C"),
    $313fbc2f3844e0dc$var$load("h3ABO"),
    $313fbc2f3844e0dc$var$load("kC80R"),
    $313fbc2f3844e0dc$var$load("7EorR"),
    $313fbc2f3844e0dc$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("gcnRn", function(module, exports) {

let $bcb04664b0e7f05a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bcb04664b0e7f05a$var$load("7do1E"),
    $bcb04664b0e7f05a$var$load("77dkW"),
    $bcb04664b0e7f05a$var$load("2YffH"),
    $bcb04664b0e7f05a$var$load("b7OPx"),
    $bcb04664b0e7f05a$var$load("lqFMg"),
    $bcb04664b0e7f05a$var$load("gELW6"),
    $bcb04664b0e7f05a$var$load("4hDGB"),
    $bcb04664b0e7f05a$var$load("2PePB"),
    $bcb04664b0e7f05a$var$load("eBRUf"),
    $bcb04664b0e7f05a$var$load("hwT9D"),
    $bcb04664b0e7f05a$var$load("j4Bpe"),
    $bcb04664b0e7f05a$var$load("h4Nf7"),
    $bcb04664b0e7f05a$var$load("7f9Fz"),
    $bcb04664b0e7f05a$var$load("8YSo7"),
    $bcb04664b0e7f05a$var$load("g9CVe"),
    $bcb04664b0e7f05a$var$load("9hYRW"),
    $bcb04664b0e7f05a$var$load("kpm7S"),
    $bcb04664b0e7f05a$var$load("6wr18"),
    $bcb04664b0e7f05a$var$load("kjZZD"),
    $bcb04664b0e7f05a$var$load("3JSgG"),
    $bcb04664b0e7f05a$var$load("9AXkC"),
    $bcb04664b0e7f05a$var$load("ffEVr"),
    $bcb04664b0e7f05a$var$load("28arV"),
    $bcb04664b0e7f05a$var$load("l1BQC"),
    $bcb04664b0e7f05a$var$load("jlSF3"),
    $bcb04664b0e7f05a$var$load("2vAWg"),
    $bcb04664b0e7f05a$var$load("7cABH"),
    $bcb04664b0e7f05a$var$load("31vk5"),
    $bcb04664b0e7f05a$var$load("4pqtR"),
    $bcb04664b0e7f05a$var$load("5XqRg"),
    $bcb04664b0e7f05a$var$load("bIPPg"),
    $bcb04664b0e7f05a$var$load("2uVTT"),
    $bcb04664b0e7f05a$var$load("hhss7"),
    $bcb04664b0e7f05a$var$load("Wowvf"),
    $bcb04664b0e7f05a$var$load("5RR9C"),
    $bcb04664b0e7f05a$var$load("h3ABO"),
    $bcb04664b0e7f05a$var$load("kC80R"),
    $bcb04664b0e7f05a$var$load("7EorR"),
    $bcb04664b0e7f05a$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("i52gf", function(module, exports) {

let $d29a729a0db7efa2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d29a729a0db7efa2$var$load("7do1E"),
    $d29a729a0db7efa2$var$load("77dkW"),
    $d29a729a0db7efa2$var$load("2YffH"),
    $d29a729a0db7efa2$var$load("b7OPx"),
    $d29a729a0db7efa2$var$load("lqFMg"),
    $d29a729a0db7efa2$var$load("gELW6"),
    $d29a729a0db7efa2$var$load("4hDGB"),
    $d29a729a0db7efa2$var$load("eBRUf"),
    $d29a729a0db7efa2$var$load("hwT9D"),
    $d29a729a0db7efa2$var$load("j4Bpe"),
    $d29a729a0db7efa2$var$load("h4Nf7"),
    $d29a729a0db7efa2$var$load("7f9Fz"),
    $d29a729a0db7efa2$var$load("8YSo7"),
    $d29a729a0db7efa2$var$load("g9CVe"),
    $d29a729a0db7efa2$var$load("9hYRW"),
    $d29a729a0db7efa2$var$load("kpm7S"),
    $d29a729a0db7efa2$var$load("6wr18"),
    $d29a729a0db7efa2$var$load("kjZZD"),
    $d29a729a0db7efa2$var$load("3JSgG"),
    $d29a729a0db7efa2$var$load("9AXkC"),
    $d29a729a0db7efa2$var$load("ffEVr"),
    $d29a729a0db7efa2$var$load("28arV"),
    $d29a729a0db7efa2$var$load("l1BQC"),
    $d29a729a0db7efa2$var$load("jlSF3"),
    $d29a729a0db7efa2$var$load("2vAWg"),
    $d29a729a0db7efa2$var$load("7cABH"),
    $d29a729a0db7efa2$var$load("31vk5"),
    $d29a729a0db7efa2$var$load("4pqtR"),
    $d29a729a0db7efa2$var$load("5XqRg"),
    $d29a729a0db7efa2$var$load("2uVTT"),
    $d29a729a0db7efa2$var$load("hhss7"),
    $d29a729a0db7efa2$var$load("Wowvf"),
    $d29a729a0db7efa2$var$load("5RR9C"),
    $d29a729a0db7efa2$var$load("2PePB"),
    $d29a729a0db7efa2$var$load("bIPPg"),
    $d29a729a0db7efa2$var$load("lnKog"),
    $d29a729a0db7efa2$var$load("h3ABO"),
    $d29a729a0db7efa2$var$load("kC80R"),
    $d29a729a0db7efa2$var$load("7EorR"),
    $d29a729a0db7efa2$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("4doEc", function(module, exports) {

let $311b7ec1ee83a155$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $311b7ec1ee83a155$var$load("2YffH"),
    $311b7ec1ee83a155$var$load("b7OPx"),
    $311b7ec1ee83a155$var$load("lqFMg"),
    $311b7ec1ee83a155$var$load("gELW6"),
    $311b7ec1ee83a155$var$load("4hDGB"),
    $311b7ec1ee83a155$var$load("1H5IN"),
    $311b7ec1ee83a155$var$load("eBRUf"),
    $311b7ec1ee83a155$var$load("hwT9D"),
    $311b7ec1ee83a155$var$load("j4Bpe"),
    $311b7ec1ee83a155$var$load("h4Nf7"),
    $311b7ec1ee83a155$var$load("7f9Fz"),
    $311b7ec1ee83a155$var$load("8YSo7"),
    $311b7ec1ee83a155$var$load("7do1E"),
    $311b7ec1ee83a155$var$load("77dkW"),
    $311b7ec1ee83a155$var$load("g9CVe"),
    $311b7ec1ee83a155$var$load("9hYRW"),
    $311b7ec1ee83a155$var$load("kpm7S"),
    $311b7ec1ee83a155$var$load("6wr18"),
    $311b7ec1ee83a155$var$load("kjZZD"),
    $311b7ec1ee83a155$var$load("3JSgG"),
    $311b7ec1ee83a155$var$load("9AXkC"),
    $311b7ec1ee83a155$var$load("ffEVr"),
    $311b7ec1ee83a155$var$load("28arV"),
    $311b7ec1ee83a155$var$load("l1BQC"),
    $311b7ec1ee83a155$var$load("jlSF3"),
    $311b7ec1ee83a155$var$load("2vAWg"),
    $311b7ec1ee83a155$var$load("7cABH"),
    $311b7ec1ee83a155$var$load("31vk5"),
    $311b7ec1ee83a155$var$load("4pqtR"),
    $311b7ec1ee83a155$var$load("5XqRg"),
    $311b7ec1ee83a155$var$load("2uVTT"),
    $311b7ec1ee83a155$var$load("hhss7"),
    $311b7ec1ee83a155$var$load("Wowvf"),
    $311b7ec1ee83a155$var$load("5RR9C"),
    $311b7ec1ee83a155$var$load("2PePB"),
    $311b7ec1ee83a155$var$load("bIPPg"),
    $311b7ec1ee83a155$var$load("lnKog"),
    $311b7ec1ee83a155$var$load("h3ABO"),
    $311b7ec1ee83a155$var$load("kC80R"),
    $311b7ec1ee83a155$var$load("7EorR"),
    $311b7ec1ee83a155$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("kFJwL", function(module, exports) {

let $f0caf3c7b012306d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f0caf3c7b012306d$var$load("2YffH"),
    $f0caf3c7b012306d$var$load("b7OPx"),
    $f0caf3c7b012306d$var$load("lqFMg"),
    $f0caf3c7b012306d$var$load("gELW6"),
    $f0caf3c7b012306d$var$load("4hDGB"),
    $f0caf3c7b012306d$var$load("1H5IN"),
    $f0caf3c7b012306d$var$load("eBRUf"),
    $f0caf3c7b012306d$var$load("hwT9D"),
    $f0caf3c7b012306d$var$load("j4Bpe"),
    $f0caf3c7b012306d$var$load("h4Nf7"),
    $f0caf3c7b012306d$var$load("7f9Fz"),
    $f0caf3c7b012306d$var$load("8YSo7"),
    $f0caf3c7b012306d$var$load("7do1E"),
    $f0caf3c7b012306d$var$load("77dkW"),
    $f0caf3c7b012306d$var$load("g9CVe"),
    $f0caf3c7b012306d$var$load("9hYRW"),
    $f0caf3c7b012306d$var$load("kpm7S"),
    $f0caf3c7b012306d$var$load("6wr18"),
    $f0caf3c7b012306d$var$load("kjZZD"),
    $f0caf3c7b012306d$var$load("3JSgG"),
    $f0caf3c7b012306d$var$load("9AXkC"),
    $f0caf3c7b012306d$var$load("ffEVr"),
    $f0caf3c7b012306d$var$load("28arV"),
    $f0caf3c7b012306d$var$load("l1BQC"),
    $f0caf3c7b012306d$var$load("jlSF3"),
    $f0caf3c7b012306d$var$load("2vAWg"),
    $f0caf3c7b012306d$var$load("7cABH"),
    $f0caf3c7b012306d$var$load("31vk5"),
    $f0caf3c7b012306d$var$load("4pqtR"),
    $f0caf3c7b012306d$var$load("5XqRg"),
    $f0caf3c7b012306d$var$load("2uVTT"),
    $f0caf3c7b012306d$var$load("hhss7"),
    $f0caf3c7b012306d$var$load("Wowvf"),
    $f0caf3c7b012306d$var$load("5RR9C"),
    $f0caf3c7b012306d$var$load("2PePB"),
    $f0caf3c7b012306d$var$load("bIPPg"),
    $f0caf3c7b012306d$var$load("lnKog"),
    $f0caf3c7b012306d$var$load("h3ABO"),
    $f0caf3c7b012306d$var$load("kC80R"),
    $f0caf3c7b012306d$var$load("7EorR"),
    $f0caf3c7b012306d$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("5shOo", function(module, exports) {

let $3f8d62588ff52c9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f8d62588ff52c9b$var$load("7do1E"),
    $3f8d62588ff52c9b$var$load("77dkW"),
    $3f8d62588ff52c9b$var$load("2YffH"),
    $3f8d62588ff52c9b$var$load("b7OPx"),
    $3f8d62588ff52c9b$var$load("lqFMg"),
    $3f8d62588ff52c9b$var$load("gELW6"),
    $3f8d62588ff52c9b$var$load("4hDGB"),
    $3f8d62588ff52c9b$var$load("2PePB"),
    $3f8d62588ff52c9b$var$load("eBRUf"),
    $3f8d62588ff52c9b$var$load("hwT9D"),
    $3f8d62588ff52c9b$var$load("j4Bpe"),
    $3f8d62588ff52c9b$var$load("h4Nf7"),
    $3f8d62588ff52c9b$var$load("7f9Fz"),
    $3f8d62588ff52c9b$var$load("8YSo7"),
    $3f8d62588ff52c9b$var$load("g9CVe"),
    $3f8d62588ff52c9b$var$load("9hYRW"),
    $3f8d62588ff52c9b$var$load("kpm7S"),
    $3f8d62588ff52c9b$var$load("6wr18"),
    $3f8d62588ff52c9b$var$load("kjZZD"),
    $3f8d62588ff52c9b$var$load("3JSgG"),
    $3f8d62588ff52c9b$var$load("9AXkC"),
    $3f8d62588ff52c9b$var$load("ffEVr"),
    $3f8d62588ff52c9b$var$load("28arV"),
    $3f8d62588ff52c9b$var$load("l1BQC"),
    $3f8d62588ff52c9b$var$load("jlSF3"),
    $3f8d62588ff52c9b$var$load("2vAWg"),
    $3f8d62588ff52c9b$var$load("7cABH"),
    $3f8d62588ff52c9b$var$load("31vk5"),
    $3f8d62588ff52c9b$var$load("4pqtR"),
    $3f8d62588ff52c9b$var$load("5XqRg"),
    $3f8d62588ff52c9b$var$load("bIPPg"),
    $3f8d62588ff52c9b$var$load("2uVTT"),
    $3f8d62588ff52c9b$var$load("hhss7"),
    $3f8d62588ff52c9b$var$load("Wowvf"),
    $3f8d62588ff52c9b$var$load("5RR9C"),
    $3f8d62588ff52c9b$var$load("h3ABO"),
    $3f8d62588ff52c9b$var$load("kC80R"),
    $3f8d62588ff52c9b$var$load("7EorR"),
    $3f8d62588ff52c9b$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("3Hycf", function(module, exports) {

let $2b1fe9f7f738c36c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2b1fe9f7f738c36c$var$load("7do1E"),
    $2b1fe9f7f738c36c$var$load("77dkW"),
    $2b1fe9f7f738c36c$var$load("2YffH"),
    $2b1fe9f7f738c36c$var$load("b7OPx"),
    $2b1fe9f7f738c36c$var$load("lqFMg"),
    $2b1fe9f7f738c36c$var$load("gELW6"),
    $2b1fe9f7f738c36c$var$load("4hDGB"),
    $2b1fe9f7f738c36c$var$load("eBRUf"),
    $2b1fe9f7f738c36c$var$load("hwT9D"),
    $2b1fe9f7f738c36c$var$load("j4Bpe"),
    $2b1fe9f7f738c36c$var$load("h4Nf7"),
    $2b1fe9f7f738c36c$var$load("7f9Fz"),
    $2b1fe9f7f738c36c$var$load("8YSo7"),
    $2b1fe9f7f738c36c$var$load("g9CVe"),
    $2b1fe9f7f738c36c$var$load("9hYRW"),
    $2b1fe9f7f738c36c$var$load("kpm7S"),
    $2b1fe9f7f738c36c$var$load("6wr18"),
    $2b1fe9f7f738c36c$var$load("kjZZD"),
    $2b1fe9f7f738c36c$var$load("3JSgG"),
    $2b1fe9f7f738c36c$var$load("9AXkC"),
    $2b1fe9f7f738c36c$var$load("ffEVr"),
    $2b1fe9f7f738c36c$var$load("28arV"),
    $2b1fe9f7f738c36c$var$load("l1BQC"),
    $2b1fe9f7f738c36c$var$load("jlSF3"),
    $2b1fe9f7f738c36c$var$load("2vAWg"),
    $2b1fe9f7f738c36c$var$load("7cABH"),
    $2b1fe9f7f738c36c$var$load("31vk5"),
    $2b1fe9f7f738c36c$var$load("4pqtR"),
    $2b1fe9f7f738c36c$var$load("5XqRg"),
    $2b1fe9f7f738c36c$var$load("2uVTT"),
    $2b1fe9f7f738c36c$var$load("hhss7"),
    $2b1fe9f7f738c36c$var$load("Wowvf"),
    $2b1fe9f7f738c36c$var$load("5RR9C"),
    $2b1fe9f7f738c36c$var$load("2PePB"),
    $2b1fe9f7f738c36c$var$load("bIPPg"),
    $2b1fe9f7f738c36c$var$load("lnKog"),
    $2b1fe9f7f738c36c$var$load("h3ABO"),
    $2b1fe9f7f738c36c$var$load("kC80R"),
    $2b1fe9f7f738c36c$var$load("7EorR"),
    $2b1fe9f7f738c36c$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("5S3Gg", function(module, exports) {

let $4464d9cf9d8cfe99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4464d9cf9d8cfe99$var$load("7do1E"),
    $4464d9cf9d8cfe99$var$load("77dkW"),
    $4464d9cf9d8cfe99$var$load("2YffH"),
    $4464d9cf9d8cfe99$var$load("b7OPx"),
    $4464d9cf9d8cfe99$var$load("lqFMg"),
    $4464d9cf9d8cfe99$var$load("gELW6"),
    $4464d9cf9d8cfe99$var$load("4hDGB"),
    $4464d9cf9d8cfe99$var$load("eBRUf"),
    $4464d9cf9d8cfe99$var$load("hwT9D"),
    $4464d9cf9d8cfe99$var$load("j4Bpe"),
    $4464d9cf9d8cfe99$var$load("h4Nf7"),
    $4464d9cf9d8cfe99$var$load("7f9Fz"),
    $4464d9cf9d8cfe99$var$load("8YSo7"),
    $4464d9cf9d8cfe99$var$load("g9CVe"),
    $4464d9cf9d8cfe99$var$load("9hYRW"),
    $4464d9cf9d8cfe99$var$load("kpm7S"),
    $4464d9cf9d8cfe99$var$load("6wr18"),
    $4464d9cf9d8cfe99$var$load("kjZZD"),
    $4464d9cf9d8cfe99$var$load("3JSgG"),
    $4464d9cf9d8cfe99$var$load("9AXkC"),
    $4464d9cf9d8cfe99$var$load("ffEVr"),
    $4464d9cf9d8cfe99$var$load("28arV"),
    $4464d9cf9d8cfe99$var$load("l1BQC"),
    $4464d9cf9d8cfe99$var$load("jlSF3"),
    $4464d9cf9d8cfe99$var$load("2vAWg"),
    $4464d9cf9d8cfe99$var$load("7cABH"),
    $4464d9cf9d8cfe99$var$load("31vk5"),
    $4464d9cf9d8cfe99$var$load("4pqtR"),
    $4464d9cf9d8cfe99$var$load("5XqRg"),
    $4464d9cf9d8cfe99$var$load("2uVTT"),
    $4464d9cf9d8cfe99$var$load("hhss7"),
    $4464d9cf9d8cfe99$var$load("Wowvf"),
    $4464d9cf9d8cfe99$var$load("5RR9C"),
    $4464d9cf9d8cfe99$var$load("2PePB"),
    $4464d9cf9d8cfe99$var$load("bIPPg"),
    $4464d9cf9d8cfe99$var$load("lnKog"),
    $4464d9cf9d8cfe99$var$load("h3ABO"),
    $4464d9cf9d8cfe99$var$load("kC80R"),
    $4464d9cf9d8cfe99$var$load("7EorR"),
    $4464d9cf9d8cfe99$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("grspz", function(module, exports) {
const $cdcead6f01277136$export$957229695d10ea4a = (extensionId)=>{
    return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};
module.exports["getLocalId"] = $cdcead6f01277136$export$957229695d10ea4a;

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("gektR", function(module, exports) {

var $T1bCI = parcelRequire("T1bCI");


var $jVylI = parcelRequire("jVylI");

class $904056f857fff237$export$e38a13e9484b72c7 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
            isUpdatingAlignment: false,
            isLoadingComplete: false
        };
        this.toggleAlignmentButton = (newAlignmentState)=>{
            if (this.state.alignmentButtonState !== newAlignmentState) this.setState({
                alignmentButtonState: newAlignmentState || (0, $jVylI.TitleAlignmentType).LEFT
            });
        };
        this.setIsLoadingComplete = (isLoadingComplete)=>{
            this.setState({
                isLoadingComplete: isLoadingComplete
            });
        };
        this.setIsUpdatingAlignment = (isUpdatingAlignment)=>{
            this.setState({
                isUpdatingAlignment: isUpdatingAlignment
            });
        };
        this.resetToDefaults = ()=>{
            this.setState({
                alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
                isUpdatingAlignment: false,
                isLoadingComplete: false
            });
        };
    }
}
module.exports["AlignmentButtonContainer"] = $904056f857fff237$export$e38a13e9484b72c7;

});

parcelRegister("80koo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cpjd2 = parcelRequire("cpjd2");

const $c65634971abef8c1$export$c2019f6d43c6c1ce = ({ wrm: wrm, children: children })=>{
    const [wrmLoadingState, setWrmLoadingState] = (0, $42omo.useState)({
        loaded: false,
        modules: []
    });
    (0, $42omo.useEffect)(()=>{
        (0, $cpjd2.requireLegacyWRM)(wrm, (modules)=>{
            setWrmLoadingState({
                loaded: true,
                modules: modules
            });
        }, ()=>{});
    }, [
        wrm
    ]);
    return wrmLoadingState.loaded && children ? children(wrmLoadingState.modules) : null;
};
module.exports["RequireLegacyWRM"] = $c65634971abef8c1$export$c2019f6d43c6c1ce;

});

parcelRegister("2UWuP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $Asv1P = parcelRequire("Asv1P");

const $1c62d6fee936c450$var$noop = ()=>{};
function $1c62d6fee936c450$export$907c57431ebf932({ children: children, analyticsData: analyticsData, innerRef: innerRef, wrapChildren: wrapChildren = false }) {
    const handler = children?.props?.onClick || $1c62d6fee936c450$var$noop;
    const handleClick = (0, $Asv1P.useCallbackWithAnalytics)(handler, analyticsData);
    if (wrapChildren) {
        const wrappedChild = /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
            onClick: handleClick
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ref: innerRef
        }, wrappedChild);
    }
    return /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onClick: handleClick,
        ref: innerRef
    });
}
module.exports["WebItemAnalyticsWrapper"] = $1c62d6fee936c450$export$907c57431ebf932;

});

parcelRegister("lfFzM", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<addb5e142aa82e94041daec88a20b086>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("6ld6a", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $jtuBN = parcelRequire("jtuBN");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipQuery || $[9] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery
        };
        $[8] = skipQuery;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), baseQueryOptions);
    if (!data) {
        let t8;
        let t9;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[11] = t8;
            $[12] = t9;
        } else {
            t8 = $[11];
            t9 = $[12];
        }
        let t10;
        if ($[13] !== error || $[14] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[13] = error;
            $[14] = loading;
            $[15] = t10;
        } else t10 = $[15];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[16] !== allowedWebItems || $[17] !== data || $[18] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        $[16] = allowedWebItems;
        $[17] = data;
        $[18] = notAllowedWebItems;
        $[19] = webItems;
        $[20] = webSections;
    } else {
        webItems = $[19];
        webSections = $[20];
    }
    let t8;
    if ($[21] !== error || $[22] !== webItems || $[23] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[21] = error;
        $[22] = webItems;
        $[23] = webSections;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});

parcelRegister("aV3a0", function(module, exports) {

var $kae7O = parcelRequire("kae7O");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9wEpK = parcelRequire("9wEpK");


var $jMyy4 = parcelRequire("jMyy4");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kqgA = parcelRequire("5kqgA");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gzIc1 = parcelRequire("gzIc1");


var $jVylI = parcelRequire("jVylI");

const $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery = (0, $kae7O.default);
const $c042cea05c5afe3c$export$56ad806c83a5bd5e = (queryData)=>queryData?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.find((node)=>node?.key === 'page-title-property-draft');
const $c042cea05c5afe3c$var$i18n = (0, $aXWIB.defineMessages)({
    errorFlagTitle: {
        id: "content-topper.page-title.alignment.error.title",
        defaultMessage: "We couldn\u2019t update the title alignment"
    },
    errorFlagDescription: {
        id: "content-topper.page-title.alignment.error.description",
        defaultMessage: "Try again, or refresh the page."
    }
});
const $c042cea05c5afe3c$export$e3e4716593714d84 = ({ contentId: contentId, propertyKey: propertyKey = 'page-title-property-draft', isDelete: isDelete = false, loadTitleContentProperties: loadTitleContentProperties = false, updateAlignmentState: updateAlignmentState, updateCoverPictureWidthState: updateCoverPictureWidthState, contentType: contentType, flags: flags, updateIsLoadingComplete: updateIsLoadingComplete })=>{
    const isInitialLoadComplete = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const isTitleCenteredInitial = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const handleError = (0, $42omo.useCallback)((error, suppressErrors)=>{
        const isUnauthOrNotFoundError = (0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error);
        if (!isUnauthOrNotFoundError) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!suppressErrors) flags?.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagDescription)
        });
    }, [
        flags
    ]);
    const getAlignmentFromContentProperty = (response)=>{
        const titlePropertyContent = $c042cea05c5afe3c$export$56ad806c83a5bd5e(response);
        if (titlePropertyContent?.value) try {
            return (0, $gzIc1.contentPropertyHelper)(titlePropertyContent)?.titleLayoutAlignment || (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        } catch (e) {
            handleError(e, false);
            return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        }
        else return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
    };
    const onCompleted = (response_0)=>{
        const coverPictureWidth = response_0.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
        updateAlignmentState?.(getAlignmentFromContentProperty(response_0));
        updateCoverPictureWidthState?.(coverPictureWidth);
    };
    const { data: data, networkStatus: networkStatus, refetch: refetchProperties } = (0, $jMyy4.useQueryInterop)($c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        fetchPolicy: Boolean(window.__SSR_RENDERED__) ? 'cache-first' : 'cache-and-network',
        // cache-and-network is required for: edit cover width, transition out of edit, transition back to edit for same page (for Live Docs and Classic pages)
        onError: (error_0)=>{
            handleError(error_0, true);
        },
        skip: !(loadTitleContentProperties || Boolean(window.__SSR_RENDERED__)),
        notifyOnNetworkStatusChange: true
    });
    const isTitleAlignmentLoading = networkStatus === (0, $9wEpK.NetworkStatus).loading && !data;
    const refetchLoading = networkStatus === (0, $9wEpK.NetworkStatus).refetch;
    const coverImageWidthCached = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth;
    isTitleCenteredInitial.current = (Boolean(window.__SSR_RENDERED__) || !isTitleAlignmentLoading) && getAlignmentFromContentProperty(data) === (0, $jVylI.TitleAlignmentType).CENTER;
    if (!isInitialLoadComplete.current && loadTitleContentProperties && data) {
        isInitialLoadComplete.current = true;
        onCompleted(data);
        updateIsLoadingComplete?.(true);
    }
    const { updateContentProperty: updateContentProperty, updateContentPropertyResult: { loading: isUpdatingAlignment } = {} } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page'
    });
    const onPageTitlePropertyUpdatedSubscriptionData = (0, $42omo.useCallback)((_eventName, response_1)=>{
        const { pageTitlePropertyUpdated: pageTitlePropertyUpdated } = response_1 || {};
        try {
            const value = JSON.parse(pageTitlePropertyUpdated?.value);
            updateAlignmentState?.(value?.titleLayoutAlignment);
        } catch (error_1) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_1, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_1);
        }
    }, [
        updateAlignmentState
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType || 'page',
        delta: 'pageTitlePropertyUpdated',
        onDataReceived: onPageTitlePropertyUpdatedSubscriptionData,
        subscriberId: 'useTitleContentPropertiesForEditor'
    });
    const updatePageTitleProperty = (0, $42omo.useCallback)(async (propertyValue)=>{
        try {
            const getVersionNumber = (data_0)=>data_0?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.[0]?.version?.number || 0;
            const versionData = await refetchProperties();
            const versionNumber = getVersionNumber(versionData.data);
            const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
            await updateContentProperty({
                propertyKey: propertyKey,
                propertyValue: propertyValue,
                isDelete: isDelete,
                hasExistingProperty: versionNumber > 0,
                shouldOptimisticResponse: true,
                options: {
                    update: ()=>{
                        try {
                            const cacheData = (0, $l1uFv.readQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                }
                            });
                            cacheData.content.nodes[0].pageTitleDraft.nodes[0] = {
                                ...cacheData.content.nodes[0].pageTitleDraft.nodes[0],
                                id: contentId,
                                key: propertyKey,
                                value: JSON.stringify(propertyValue),
                                version: {
                                    number: newVersionNumber,
                                    __typename: 'Version'
                                }
                            };
                            (0, $fEmGS.writeQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                data: data
                            });
                        } catch (error_2) {
                            throw new Error(` failed to write to cache while updating ${propertyKey} content property after user updated page title${error_2.message}`);
                        }
                    }
                }
            });
        } catch (err) {
            handleError(err, false);
        }
    }, [
        propertyKey,
        contentId,
        isDelete,
        updateContentProperty,
        refetchProperties,
        data,
        handleError
    ]);
    return {
        isUpdatingAlignment: isUpdatingAlignment || refetchLoading,
        updatePageTitleProperty: updatePageTitleProperty,
        onCompleted: // exported for testing purposes
        onCompleted,
        isTitleAlignmentLoading: isTitleAlignmentLoading,
        isTitleCenteredInitial: isTitleCenteredInitial.current,
        coverImageWidthCached: coverImageWidthCached
    };
};
module.exports["useTitleContentPropertiesForEditor"] = $c042cea05c5afe3c$export$e3e4716593714d84;

});


//# sourceMappingURL=EditorByLineArea.f45723e5.js.map
